import { NavLink, useNavigate } from "react-router-dom";
import Button from "../components/Button";
import styles from "./SettingsMenu.module.css";
import React from "react";

function SettingsMenu() {
  const navigate = useNavigate();
  return (
    <>
      <div className={styles.backButton}>
        <Button
          type="tertiary"
          onClick={(e) => {
            e.preventDefault();
            navigate("/");
          }}
        >
          Back to Calendar
        </Button>
      </div>

      <ul className={styles.menuList}>
        <li>
          <NavLink to="users">User Administration</NavLink>
        </li>
        <li>
          <NavLink to="menu">Add/Edit Menu Items</NavLink>
        </li>
      </ul>
    </>
  );
}

export default SettingsMenu;
